export const MAX_Z_INDEX = 'var(--above-all-z-index) !important'
export const WRICH_TEXT_COMP_TYPE = 'WRichText'
